var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib/index.js';
import { StringUtility } from '@inter-ikea-kompis/utilities';
import { Text } from '@inter-ikea-kompis/component-text';
import WoodDeclarationCardStyle from './WoodDeclarationCardStyle.js';
const WOOD_DECLARATION_CODE = '00692';
/**
 * Wood declaration card sub component.
 */
export default class WoodDeclarationCard extends KompisElement {
    constructor() {
        super(...arguments);
        // Show type of wood header.
        this.showHeader = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        if (!this.product?.content?.complianceInformation?.find((compliance) => compliance.datasetCode === WOOD_DECLARATION_CODE)) {
            return null;
        }
        return html `
			<style>
				${WoodDeclarationCardStyle.getStyle({
            theme: this.theme
        })}
			</style>
			<div class="container">${this.getWoodDeclarationHeader()}${this.getWoodDeclaration()}</div>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    /**
     * Returns the wood type and country of harvest from the product data.
     */
    getWoodDeclaration() {
        const woodDeclarationInformation = this.product?.content?.complianceInformation
            ?.filter((info) => info.datasetCode === WOOD_DECLARATION_CODE)
            .map((info) => info.text);
        if (!woodDeclarationInformation) {
            return null;
        }
        // Match 0 = Everything.
        // Match 1 = Tree name.
        // Match 2 = Scientific tree name.
        // Match 3 = Country header.
        // Match 4 = Countries.
        const regexp = /[^;]*;([^(]+)\(([^)]+)[^;]*;([^:]+):[ ]*(.+)/;
        return woodDeclarationInformation.map((info) => {
            const match = info.match(regexp) || '';
            return html `<div class="row">
				${this.getComplianceHeader({
                name: match[1],
                scientificName: match[2]
            })}${this.getComplianceData({
                header: match[3],
                countries: match[4]
            })}
			</div>`;
        });
    }
    /**
     * Returns the wood declaration.
     */
    getComplianceHeader(options) {
        return html `<kompis-text
			class="header"
			.type="${ThemeFontStyleTypeEnum.headingXSmall}"
			.theme="${this.theme}"
			>${`${options.name} (${options.scientificName})`}</kompis-text
		>`;
    }
    /**
     * Returns the country of harvest data.
     *
     * @param options Options.
     * @param options.header Country of harvest header.
     * @param options.countries Countries.
     */
    getComplianceData(options) {
        const lowerCaseCountries = options.countries
            .split(',')
            .map((country) => StringUtility.capitalizeFirstLetter(country.trim().toLocaleLowerCase()))
            .join(', ');
        return html `<kompis-text class="data" .theme="${this.theme}"
			>${`${options.header.trim()}: ${lowerCaseCountries}`}</kompis-text
		>`;
    }
    /**
     * Returns header for accordion from data.
     */
    getWoodDeclarationHeader() {
        if (!this.showHeader) {
            return '';
        }
        const header = this.product.content?.complianceInformation?.find((compliance) => compliance.headingText)
            ?.headingText || null;
        if (!header) {
            return '';
        }
        return html `<kompis-text
			class="woodDeclarationHeader"
			.theme="${this.theme}"
			.type="${ThemeFontStyleTypeEnum.headingXSmall}"
			>${header}</kompis-text
		>`;
    }
}
__decorate([
    property({ type: Object, required: true })
], WoodDeclarationCard.prototype, "theme", void 0);
__decorate([
    property({ type: Object, required: true })
], WoodDeclarationCard.prototype, "product", void 0);
__decorate([
    property({ type: Boolean })
], WoodDeclarationCard.prototype, "showHeader", void 0);
//# sourceMappingURL=WoodDeclarationCard.js.map